import { render } from "./search-index.vue?vue&type=template&id=56b85a7a"
import script from "./search-index.vue?vue&type=script&lang=js"
export * from "./search-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__